import { PlayerAdapterPerformanceMode } from 'library/ts/player/adapter/enums/PlayerAdapterPerformanceMode';
import { IParamsVO } from 'tag/ts/tag/interfaces/params/IParamsVO';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';

export class PlayStation4 extends AbstractSTVPlatformConfig {

	constructor( params: IParamsVO ) {
		super( params );
		this.configs = this.utils.DeepMerge.deepmerge( this.configs, {
			properties: {
				device: EmbedDevice.PS4
			},
			playerOptions: {
				performanceMode: PlayerAdapterPerformanceMode.LOW
			},
			resourceConfig: {
				manifest: {
					dash: {
						ignoreMinBufferTime: true // ignore buffer setting in manifest
					}
				},
				// PLSTVVID-1464: optimal buffer settings derived by Agajan to solve buffer loop issue. Consult VTG before changing.
				playback: {
					streaming: {
						bufferBehind: 2, // amount of buffer to keep behind
						bufferingGoal: 6, // amount to buffer whilst playing
						rebufferingGoal: 18 // amount to buffer pre-playback / post-seek
					}
				}
			}
		} );
	}

}